import { NameCellRenderer } from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } =
  TABLE_INFO.ONPREM_LOWEST_COMPLIANCE;

export const cloudLowestComplianceColumnDefs = [
  {
    headerName: tableHeader.NAME,
    field: tableProps.NAME,
    flex: 4,
    filter: false,
    cellRenderer: NameCellRenderer,
    lockPosition: true,
    lockPinned: true,
    cellRendererParams: {
      fieldMapping: {
        ...tableProps,
      },
    },
  },
  // {
  //   headerName: tableHeader.NIST,
  //   field: tableProps.NIST,
  //   flex: 5,
  //   valueGetter: (params: any) => {
  //     const compliance = params.data.compliance || [];
  //     const nistData = compliance.find((c: any) => c.name === tableHeader.NIST);
  //     return nistData ? nistData.percentage : 0;
  //   },
  //   cellRenderer: ComplianceCellRenderer,
  //   filter: false,
  //   sortable: true,
  //   sort: "asc",
  // },
  // {
  //   headerName: tableHeader.CSC,
  //   field: tableProps.CSC,
  //   flex:4,
  //   valueGetter: (params: any) => {
  //     const compliance = params.data.compliance || [];
  //     const cscData = compliance.find((c: any) => c.name === tableHeader.CSC);
  //     return cscData ? cscData.percentage * 100 : 0;
  //   },
  //   cellRenderer: ComplianceCellRenderer,
  //   filter: false,
  //   sortable: true,
  //   sort: "asc",
  // },
];
